module.exports = __webpack_public_path__ + "img/French Polynesia.2cc4e51a.svg";